import countries from '@/ui/countries.json'

type CountryEntry = { name: string; code: string }

export function countryNameToCode(input: string | undefined | null): string {
  if (!input) return ''
  const norm = input.trim().toLowerCase()
  if (!norm) return ''
  if (norm.length === 2) return norm.toUpperCase()
  const match = (countries as CountryEntry[]).find(
    c => c.name.trim().toLowerCase() === norm
  )
  return match?.code ?? ''
}
